export default "__VITE_ASSET__DMNvj9Cn__"